import { Tabs } from 'antd';
import { usePermission } from '@/shared/lib/usePermission';
import { AccessMatrixCard } from './AccessMatrixCard';
import { AuditLogCard } from './AuditLogCard';
import { NotificationsTab } from './NotificationsTab';
import { UsersCard } from './UsersCard';
import s from './Admin.module.scss';

export function Admin() {
  const admin = usePermission('Администрирование и настройки');
  const auditPerm = usePermission('Журнал безопасности');
  const usersPerm = usePermission('Пользователи');

  const showUsersCard = usersPerm.canView;
  const showAuditLog = auditPerm.canView;
  const showAccessMatrix = admin.canView;

  const settingsTabChildren = (
    <div className={s.root__stack}>
      {showUsersCard && <UsersCard readOnly={!usersPerm.canEdit} />}
      {showAccessMatrix && <AccessMatrixCard />}
      {showAuditLog && <AuditLogCard />}
    </div>
  );

  const tabs = [
    {
      key: 'main',
      label: 'Настройки',
      children: settingsTabChildren,
    },
  ];

  if (admin.canEdit) {
    tabs.push({
      key: 'notifications',
      label: 'Уведомления',
      children: <NotificationsTab />,
    });
  }

  return <Tabs items={tabs} />;
}
